import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'TalentPool';
  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.initializeUser();
  }
}
